import script from "./PCPartsItemCardBody.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsItemCardBody.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsItemCardBody.vue?vue&type=style&index=0&id=3303063e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3303063e"]])

export default __exports__